import View from './view';
import {Props} from './model';
import {reduxForm} from 'redux-form';
import {Forms} from '../../../../shared/models/forms';
import * as React from 'react';

const Form = reduxForm<Props, any>({form: Forms.pollForm, destroyOnUnmount: true})(View);

export const PollFormScreenWrapper = (props: Props) => {
  return React.createElement(Form, props);
};
